import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import CheckoutSteps from "../../../../constants/CheckoutSteps";
import { redirectToAction } from "../../redirection/actions";
import { getSessionData } from "../../sessionData/actions";
import ActionTypes from "../../../../constants/ActionTypes";
import { apiRequest } from "../../api/actions";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { setLoader } from "../../ui/actions";
import { ISubmitOrderRequestProduct } from "./types";
import { getNotification, setNotification } from "../../notification/actions";
import { INotification } from "../../notification/types";
import createId from "../../../../utilites/createid";
import NotificationTypes from "../../../../constants/NotificationTypes";
import { prepareUrlForRedirectToCheckout } from "../../../../utilites/util";

export const submitPersonalizedProductOvervieworderMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  const language = store.getState().language.language as "sr" | "en";
  const labels = require(`../../../../translations/${language}`);

  const errorNotification: INotification[] = [{
    id: parseInt(createId("")),
    type: NotificationTypes.types.ERROR,
    message: labels.errorMessage,
    cssClass: NotificationTypes.cssClass.ALERT_DANGER
  }];

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.PURCHASE_FTTH_SUBMIT:
    const productData = store.getState().productData;
    const contract = store.getState().contracts.items[0].contract;
    const submitOrderParams: ISubmitOrderRequestProduct = {
      segment: store.getState().section.section,
      selectedProducts: [{
        id: Number(productData.product.item.id),
        productLine: productData.product.item.productLine.productLine,
        purchaseType: productData.productData.paymentType,
        custcode: contract.custcode,
        contractDuration: Number(contract.duration),
        colorId: parseInt(productData.productData.color),
      }],
      lang: store.getState().language.language
    };

    next(apiRequest(
      null,
      'POST', `${ApiUrls.ORDER_SUBMIT}`,
      null,
      submitOrderParams,
      MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT));
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT} ${ActionTypes.API_SUCCESS}` :
    next(setLoader(false, MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT));
    next(getSessionData(action.payload.data.session));
    next(getNotification(action.payload.data.session.flashMessages, MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT));
    next(redirectToAction(prepareUrlForRedirectToCheckout(language, store.getState().section.section, CheckoutSteps[language].checkout)));
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT} ${ActionTypes.API_ERROR}` :
    next(setNotification(errorNotification, MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT));
    next(setLoader(false, MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT));
    break;
  }
};

export const personalizedProductOverviewOrderMiddleware = [submitPersonalizedProductOvervieworderMiddleware];

